export const GET_MONTHS_LIST = `
  query AvailableMonthsQuery {
    listAvailableMonths
  }
`
export const FOOT_TRAFFIC_TREND_QUERY = `
  query FootTraffiTrendQuery($brandId: Int!, $sicCode: String!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    marketShare(requestId: "09ac92b9-b00e-4298-9bcb-368766f26be5", brandId: $brandId, sicCode: $sicCode, 
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue, limit: 10) {
      marketShareTrend {
        footTrafficTrend {
          brand {
            brandId
            brandName
            visits
            category{
              sicCode,  
              categoryName,
              visits
            }
          }
        }
      }
    }
  }`

export const MONTHLY_TREND_QUERY = `
  query MonthlyTrendQuery($brandId: Int!, $sicCode: String!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    marketShare(requestId: "09ac92b9-b00e-4298-9bcb-368766f26be5", brandId: $brandId, sicCode: $sicCode, 
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue, limit: 10) {
      requestId
        marketShareTrend {
          monthlyTrend{
            month
            brand{
              brandId
              brandName
              visits
              category{
                sicCode,
                categoryName,
                visits
            }
          }
        }
      }
    }
  }`

export const REGIONAL_TREND_QUERY = `
  query RegionalTrendQuery($brandId: Int!, $sicCode: String!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    marketShare(requestId: "09ac92b9-b00e-4298-9bcb-368766f26be5", brandId: $brandId, sicCode: $sicCode, 
      month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue, limit: 10) {
      marketShareTrend {
        regionalTrend{ 
         region
         brand {
             brandId
             brandName
             visits
             category{
              sicCode,
              categoryName,
              visits
          }
         }
        }
      }
    }
  }`

export const MARKET_COMPOSITION_QUERY = `
  query MarketCompositionQuery($brandId: Int!, $sicCode: String!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    marketShare(requestId: "09ac92b9-b00e-4298-9bcb-368766f26be5", brandId: $brandId, sicCode: $sicCode, 
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue, limit: 15) {
      marketShareRegional{
        marketComposition{
          category {
            sicCode
            categoryName
            visits
            brands{
              brandId
              brandName
              visits
            }
          }
        }
      }
    }
  }`

export const LOCAL_MARKETSHARE_QUERY = `
  query LocalMarketShareQuery($brandId: Int!, $sicCode: String!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
      marketShare(requestId: "09ac92b9-b00e-4298-9bcb-368766f26be5", brandId: $brandId, sicCode: $sicCode, 
      month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue, limit: 15) {
        marketShareRegional{
          localMarketShare{
            dma{
              dmaCode,
              brand {
                brandId
                brandName
                visits
                category {
                  sicCode
                  categoryName
                  visits
                }
              }
            }
          }
        }
      }
  }`

export const CROSSOVER_BRANDS_QUERY = `
  query CrossOverBrandsQuery($brandId: Int!, $sicCode: String!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    marketShare(requestId: "09ac92b9-b00e-4298-9bcb-368766f26be5", brandId: $brandId, sicCode: $sicCode, 
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue, limit: 25) {
        marketShareOfCrossOverBrands{
            brandName
            brandId
            crossVisits
        }
    }
  }`

export const DAY_WEEK_MARKET_SHARE = `
  query DayWeekMarketShare($brandId: Int!, $sicCode: String!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    marketShare(requestId: "09ac92b9-b00e-4298-9bcb-368766f26be5", brandId: $brandId, sicCode: $sicCode, 
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue, limit: 10) {
      marketShareDays{
        dayOfWeekVisit {
          dayOfWeek
          brand {
            brandId
            brandName
            visits
            category {
              visits
              categoryName
            }
          }
        }
      }
    }
  }`

export const DAY_TIME_MARKET_SHARE_QUERY = `
  query DayTimeMarketShare($brandId: Int!, $sicCode: String!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    marketShare(requestId: "09ac92b9-b00e-4298-9bcb-368766f26be5", brandId: $brandId, sicCode: $sicCode, 
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue, limit: 10) {
      marketShareDays {
        timeOfDayVisit {
          hour
          brand {
            brandId
            brandName
            visits
            category {
              visits
              categoryName
              sicCode
            }
          }
        }
      }
    }
  }`

export const FOOT_TRAFFIC_VS_COMPETITION = `
  query FootTrafficVsCompetition($brandId: Int!, $compBrands: [Int]!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    footTraffic(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandId: $brandId, 
      competitorBrandIds: $compBrands
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue) {
      footTrafficVsCompetition {
        marketTypeValue
        brand {
          brandId
          brandName
          visits
        }
      }
    }
  }`

export const MONTH_OVER_MONTH_FOOT_TRAFFIC = `
  query MonthOverMonthFootTraffic($brandId: Int!, $compBrands: [Int]!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    footTraffic(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandId: $brandId, 
      competitorBrandIds: $compBrands
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue) {
      monthOverMonthFootTraffic {
        month
        brand {
          brandId
          brandName
          visits
        }
      }
    }
  }`

export const DAY_WEEK_FOOT_TRAFFIC = `
  query DayWeekFootTraffic($brandId: Int!, $compBrands: [Int]!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    footTraffic(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandId: $brandId, 
      competitorBrandIds: $compBrands
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue) {
      footTrafficByDayOfWeek {
        day
        brand {
          brandId
          brandName
          visits
        }
      }
    }
  }`

export const DAY_TIME_FOOT_TRAFFIC = `
  query DayTimeFootTraffic($brandId: Int!, $compBrands: [Int]!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    footTraffic(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandId: $brandId, 
      competitorBrandIds: $compBrands
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue) {
      footTrafficByTimeOfDay {
        hour
        brand {
          brandId
          brandName
          visits
        }
      }
    }
  }`

export const TIME_PERIOD_FOOT_TRAFFIC = `
  query TimePeriodFootTraffic($brandId: Int!, $compBrands: [Int]!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    footTraffic(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandId: $brandId, 
      competitorBrandIds: $compBrands
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue) {
      footTrafficByTimePeriod{
        timePeriod
        brand {
          brandId
          brandName
          visits
        }
      }
    }
  }`

export const TIME_PERIOD_FOOT_TRAFFIC_SHARE = `
  query TimePeriodFootTrafficShare($brandId: Int!, $compBrands: [Int]!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    footTraffic(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandId: $brandId, 
      competitorBrandIds: $compBrands
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue) {
      shareOfFootTrafficByTimePeriod{
        timePeriod
        brand {
          brandId
          brandName
          visits
        }
      }
    }
  }`

export const TOP_15_BRAND_AFFINITY = `
query Top15BrandAffinity($brandId: Int!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!){
  brandAffinity(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandId: $brandId, 
    competitorBrandIds: [],
  month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue){
    marketType
    brandAffinityTop15{
      marketTypeValue
      brand{
        brandId
        brandName,
        affinityIndex,
        category{
          sicCode
          categoryName
        }
      }
    }
  }
}`

export const BOTTOM_15_BRAND_AFFINITY = `
query Bottom15BrandAffinity($brandId: Int!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!){
  brandAffinity(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandId: $brandId, 
    competitorBrandIds: [],
  month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue){
    marketType
    brandAffinityBottom15{
      marketTypeValue
      brand{
        brandId
        brandName,
        affinityIndex,
        category{
          sicCode
          categoryName
        }
      }
    }
  }
}`

export const BEHAVIORAL_AUDIENCE_AFFINITY = `
query BehavioralAudienceAffinity($brandId: Int!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!, $baCodes: [String]){
  brandAffinity(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandId: $brandId, 
  month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue, baCodes: $baCodes){
    marketType
    behavioralAudiencesAffinity{
      brandId
      baMarket{
        marketTypeValue,
        behaviouralAudience{
          baCode
          affinityIndex
        }
      }
    }
  }
}`

export const AUDIENCE_AFFINITY = `
query AudienceAffinity($brandIds: [Int], $sicCodes: [String], $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!, $baCode: String!, $sicCodeBrandMap: String){
  audienceAffinity(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandIds: $brandIds, 
  sicCodes: $sicCodes,month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue,baCode: $baCode, sicCodeBrandMap: $sicCodeBrandMap){
    marketType
    audienceBrandAffinity{
      marketTypeValue
      brand{
        brandId
        brandName
        affinityIndex
      }
    }
  }
}`

export const MONTH_OVER_MONTH_FOOT_TRAFFIC_QUICK_VIEW = `
  query MOMFootTraffic($brandId: Int!, $month: Date!, $marketType: MarketType!, $marketTypeValue: [Int]!) {
    quickView(requestId: "09ac92b9-b00e-4298-9bcb-368766f26b678", brandId: $brandId,
    month: $month, marketType: $marketType, marketTypeValue: $marketTypeValue) {
      momFootTraffic {
        month
        brand {
          brandId
          brandName
          visits
        }
      }
    }
  }`
